import { render, staticRenderFns } from "./tool.vue?vue&type=template&id=0afde4b2&scoped=true&"
import script from "./tool.vue?vue&type=script&lang=js&"
export * from "./tool.vue?vue&type=script&lang=js&"
import style0 from "./tool.vue?vue&type=style&index=0&id=0afde4b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afde4b2",
  null
  
)

export default component.exports